import { observable } from 'mobx'

class Store {
  @observable tab = '1' // 1. 合作订单明细，2. 流水明细

  changeTab = tab => {
    this.tab = tab
  }
}

export default Store
